<template>
    <div>
         <div style="background: #ffffff;position:relative;">
            <div class="search-condition-con" :class="'show'">
                <div class="search-condition">
                    <span class="label">城市</span>
                    <div class="input-condition">
                          <city-auto-complete  @getEmit="getEmitData" ref="citySear"></city-auto-complete>
                    </div>
                </div>
                <el-button type="primary" @click="handleSearch" class="subway-search-btn">查 询</el-button>
                <el-button  @click="resetSearch()" class="subway-search-btn">清空条件</el-button>
            </div>
    </div>
    <div class="level-container">
        <div class="level-list">
            <div class="area" v-for="(data, index) in list" :key="data.id">
                <h1 class="title">{{data.name}}</h1>
                <div class="level-content">
                    <div class="level-item"
                         v-for="(area, key) in dataList[data['key']]"
                         :key="key"
                         :class="getClass(area, data.type)"
                         @click.stop.prevent="getDetail(index, area, data.type)"
                    >
                        <span class="label">{{area.id}}</span>
                        <div class="level-flex" v-if="editCode !== data.type + '_'+ area.id">
                            <span class="list">{{area.name}}</span>
                            <div class="icon-operation-list">
<!--                                目前不做修改删除-->
<!--                                <i class="el-icon-edit-outline icon-ope" @click.stop.prevent="editCode = `${data.type}_${area.id}`"></i>-->
<!--                                <i class="el-icon-back icon-ope icon-ope-up" @click.stop.prevent="translatePosition(data.type, true, key)" v-if="dataList[data['key']].length > 1"></i>-->
<!--                                <i class="el-icon-back icon-ope icon-ope-down" @click.stop.prevent="translatePosition(data.type, false, key)" v-if="dataList[data['key']].length > 1"></i>-->
<!--                                <i class="el-icon-delete icon-ope" @click.stop.prevent="deleteArea(data.type, area, key)"></i>-->
                            </div>
                        </div>
                        <div class="level-flex" v-else>
                            <el-input v-model="area.modelValue" class="list-input"></el-input>
                            <div class="icon-edit-operation-list">
                                <i class="el-icon-check icon-ope" @click.stop.prevent="confirmEdit(data.type, area, key)"></i>
                                <i class="el-icon-close icon-ope" @click.stop.prevent="cancelEdit(area)"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 关联转移区域 -->
        <el-dialog title="提示" :visible.sync="isNeedTransform" center width="550px" custom-class="transform-dialog">
            <div>
                <h1 class="transform-title">
                    该区域下已关联楼盘,需要先转移楼盘区域,请选择转移区域
                </h1>
                <div class="align-center">
                    <!-- <el-cascader v-model="selectedOptions" filterable :props="{value: 'value'}"></el-cascader> -->
                </div>
                <div class="align-center btn-operate">
                    <el-button type="primary">确认转移</el-button>
                    <el-button>取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
    </div>
   
</template>
<script>
    import { getCities } from '@/service/site'
    import CityAutoComplete from "../../../components/auto-complete/city-auto-complete";
    export default {
        name: 'List',
        components: {
        CityAutoComplete,
    },
        data () {
            const list = [
                { key: 'province_list', type: 'province', name: '省/自治区/直辖市', isNeedAdd: false},
                { key: 'city_list', type: 'city', name: '地级市', isNeedAdd: true},
                { key: 'district_list', type: 'district', name: '市辖区/县/县级市', isNeedAdd: true},
                { key: 'town_list', type: 'town', name: '镇级', isNeedAdd: true},
            ]
            let info = { dataList: {}, list: list }
            list.map((item) => {
                info[`current_${item.type}`] = ''
                info.dataList[`${item.type}_list`] = []
            })
            return {
                areaList: [],
                propData:null,
                isAddArea: false,
                addAreaText: '',
                editCode: '', // 当前正在修改的code
                isNeedTransform: false, // 是否打开需要转移弹层
                ...info,
                searchData:null
            }
        },
        mounted () {
            this.initList(-1,0,0,0,0)
        },
        methods: {
            /** 初始化展示数据 type: -1，全部； 0，省； 1，市； 2，区； 3，镇； */
            async initList (type,id1,id2,id3,id4) {
                const loading = this.$loading({
                    lock: true,
                    spinner: 'el-icon-loading',
                    text: '正在请求数据，请稍后',
                    background: 'rgba(0, 0, 0, 0.1)',
                    customClass: 'level-loading'
                })
                if (type < 0) {
                    let query = {'up_id':0,'level':1}
                    await getCities(query).then((data) => {
                        const provinceList = data
                        console.log(data)
                        this.$set(this.dataList, 'province_list', provinceList)
                        if(id1!=0){
                            let index1;
                            data.forEach((el,index) => {
                                if(el.id==id1){
                                    index1=index
                                }
                            });
                            this.current_province = provinceList[index1]
                        }else{
                            this.current_province = provinceList[0]
                        }
                       
                    })
                }
                if (type < 1) {
                    if (this.current_province.id != undefined) {
                        let query = {'up_id':this.current_province.id,'level':this.current_province.level+1}
                        await getCities(query).then((data) => {
                            const cityList = data
                            this.$set(this.dataList, 'city_list', cityList)
                            if(id2!=0){
                                let index1;
                                data.forEach((el,index) => {
                                    if(el.id==id2){
                                        index1=index
                                    }
                                });
                                this.current_city = cityList[index1]
                            }else{
                               this.current_city = cityList[0]
                            }
                        })
                    }
                }
                if (type < 2) {
                    if (this.current_city.id != undefined) {
                        let query = {'up_id':this.current_city.id,'level':this.current_city.level+1}
                        await getCities(query).then((data) => {
                            const districtList = data
                            this.$set(this.dataList, 'district_list', districtList)
                             if(id3!=0){
                                let index1;
                                data.forEach((el,index) => {
                                    if(el.id==id3){
                                        index1=index
                                    }
                                });
                               this.current_district = districtList[index1]
                            }else{
                               this.current_district = districtList[0]
                            }
                        })
                    }
                }
                if (type < 3) {
                    if (this.current_district.id != undefined) {
                        let query = {'up_id':this.current_district.id,'level':this.current_district.level+1}
                        await getCities(query).then((data) => {
                            const townList = data
                            this.$set(this.dataList, 'town_list', townList)
                            if(id4!=0){
                                let index1;
                                data.forEach((el,index) => {
                                    if(el.id==id4){
                                        index1=index
                                    }
                                });
                               this.current_town = townList[index1]
                            }else{
                               this.current_town = townList[0]
                            }
                        })
                    }
                }
                loading.close()
            },
            getClass (row, type) {
                let className = ''
                if (row.id === this[`current_${type}`].id) className += ' active'
                if (this.editCode === type + '_' + row.id) className += ' is-edit'
                return className
            },
            getDetail (index, data, type) {
                this[`current_${type}`] = data
                this.initList(index,0,0,0,0)
            },
            getEmitData(data){//拿到查询数据
                this.searchData=data;
                
            },
            handleSearch () {
                let level=this.searchData.level;
                let up_levels=Object.values(this.searchData.up_levels);
                let id1=0,id2=0,id3=0,id4=0;
                let arr=[];
                if(level==1){
                    id1=this.searchData.id
                    this.initList(-1,id1,id2,id3,id4)
                }
                if(level==2){
                    id1=up_levels[0].id;
                    id2=this.searchData.id
                    this.initList(-1,id1,id2,id3,id4)
                }
                if(level==3){
                    id1=up_levels[1].id;
                    id2=up_levels[0].id;
                    id3=this.searchData.id
                    this.initList(-1,id1,id2,id3,id4)
                }
                 if(level==4){
                    id1=up_levels[2].id;
                    id2=up_levels[1].id;
                    id3=up_levels[0].id;
                    id4=this.searchData.id
                    this.initList(-1,id1,id2,id3,id4)
                }
            
            },
            toggleEdit (row, status) {
                this.$set(row, 'isEdit', status)
                this.addAreaText = ''
                this.isAddArea = false
            },
            confirmEdit (type, data, index) {
                if (data.modelValue.length > 35) {
                    this.$message({
                        type: 'error',
                        message: '添加内容长度不超过35个字符'
                    })
                    this.cancelEdit()
                    return null
                }
                // RODO--- 发送修改请求/重复名称判断
                this.$set(data, 'name', data.modelValue)
                this.editCode = ''
            },
            cancelEdit (data) {
                this.$set(data, 'modelValue', data.name)
                this.editCode = ''
            },
            async confirmAdd (type) {
                if (this.addAreaText.length > 35) {
                    this.$message({
                        type: 'error',
                        message: '添加内容长度不超过35个字符'
                    })
                    return null
                }
                const loading = this.$loading({
                    lock: true,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.05)',
                    customClass: 'level-loading'
                })
                // 模拟请求后台保存接口
                const id = await new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(parseInt(Math.random() * 100))
                    }, 1000)
                })
                loading.close()
                this.dataList[`${type}_list`].unshift({ id, name: this.addAreaText, modelValue: this.addAreaText })
                this.cancelAdd()
            },
            cancelAdd () {
                this.addAreaText = ''
                this.editCode = ''
            },
            deleteArea (type, data, index) {
                this.$confirm('确认删除?', '删除提示', {
                    center: 'center'
                }).then(() => {
                    // @TODO 发送请求 判断是否关联
                    const relatived = true
                    if (!relatived) {
                        this.areaList.splice(index, 1)
                    } else {
                        this.isNeedTransform = true
                    }
                })
            },
            translatePosition (type, status, index) {
                const newIndex = status ? index - 1 : index + 1
                const list = this.dataList[`${type}_list`]
                if (newIndex === -1 || newIndex === list.length) return null
                list[index] = list.splice(newIndex, 1, list[index])[0]
            },
            resetSearch(){//清空搜索条件，刷新页面
                this.$refs.citySear.onClean();
                this.initList(-1,0,0,0,0)
            },
        }
    }
</script>
<style scoped>
    .level-container .area{
        min-width: 250px;
    }
    .ml0{
        margin-left: 0 !important;
    }
    div .active{
        border-bottom: ridge;
        border-top: ridge;
    }
    .subway-search-btn{
        height: 36px;
        line-height: 36px;
        padding: 0 20px;
    }
</style>
